"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.helpUrl = exports.baseV2Url = exports.baseUrl = void 0;
var baseUrl = '/api/profiles/v1';
exports.baseUrl = baseUrl;
var baseV2Url = '/api/profiles/v2';
exports.baseV2Url = baseV2Url;
var helpUrl = "".concat(baseUrl, "/help");
exports.helpUrl = helpUrl;
